/**
 * Converts DataUIParts (see ./types) to parts of the user's message: text for
 * the hidden context block, and files that ride beside it.
 */

import type { DataUIPart, FileUIPart, TextPart } from "ai";
import debug from "debug";

import { convertCheckpoints } from "./checkpoints";
import { convertCommentAsk } from "./commentAsk";
import { convertFocusedSketch } from "./focusedSketch";
import { convertScreenshot } from "./screenshot";
import type { StudioDataUIParts } from "./types";

const log = debug("apprentices:dataParts:converters");

export const studioDataUIConverter = (part: DataUIPart<StudioDataUIParts>) => {
  let result: TextPart | FileUIPart | undefined;
  switch (part.type) {
    case "data-focusedSketch":
      result = convertFocusedSketch(part.id || "unnamed sketch", part.data);
      break;
    case "data-screenshot":
      result = convertScreenshot(part.data);
      break;
    case "data-checkpoints":
      result = convertCheckpoints(part.data);
      break;
    case "data-commentAsk":
      result = convertCommentAsk(part.data);
      break;
    default:
      result = undefined; // Skip it!
  }
  log("Converting %o to %o", part, result);
  return result;
};
